import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import {PopupDialog} from 'app/utils/modals/PopupDialog';
import FreespinInterface from 'app/interfaces/Freespinsinterface';
import {getActivateClickHandler} from 'app/helpers/free_spin_helpers';
import FreespinsContentItem from 'app/components/my_profile/freespins/FreespinsContentItem';

interface PopupFreespinsProps {
    popupId: string;
    free_spin_data: FreespinInterface;
}

export default class PopupFreespins extends PureComponent<PopupFreespinsProps> {
    render(): ReactNode {
        const spin = this.props.free_spin_data;
        return (
            <PopupDialog id={this.props.popupId} setFocus>
                <div className="popup__content">
                    <div className="freespins-congratulation">
                        <h3 className="freespins-congratulation__title">{I18n.t('free_spins_received')}</h3>
                        <div className="freespins-congratulation__content">
                            <FreespinsContentItem spin={spin} />
                            <button
                                className="button-adaptive freespins-congratulation__button"
                                onClick={getActivateClickHandler(spin.game_id, {casino_page: true})}
                            >
                                {I18n.t('go_game')}
                            </button>
                        </div>
                        <div className="freespins-congratulation__background">
                            <div className="freespins-congratulation__line"></div>
                            <div className="freespins-congratulation__semi-spehere-wrapper">
                                <div className="freespins-congratulation__semi-spehere"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </PopupDialog>
        );
    }
}
